export default __webpack_public_path__ + "static/media/like.32cbce1b.svg";